import React, {Component} from 'react';
import MaterialIcon from '../../../MaterialIcon';
import {connect} from "react-redux";
import {
    addUpdaterContextProperty,
    removeContextUpdater,
    removeUpdaterContextProperty,
    updateContextUpdater,
    updateUpdaterContextProperty
} from "../../../../actions/contextUpdaterActions";
import {
    addContextProperty,
    removeContextProperty,
    updateContextProperty
} from "../../../../actions/contextPropertiesActions";
import messageCodes from "../../../../utils/messageCodes";
import {showToastForFrontend} from "../../../../actions/toastActions";
import ContextPropertyEditor from "./ContextPropertyEditor";
import {InputDragHandle} from "../InputPortListUtils/InputEntry/components/InputDragHandle";

class ContextUpdater extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEditSelected: false
        };
        this.onEditSelected = this.onEditSelected.bind(this);
        this.onDeleteSelected = this.onDeleteSelected.bind(this);
        this.addContextProperty = this.addContextProperty.bind(this);
        this.deleteContextProperty = this.deleteContextProperty.bind(this);
        this.updateContextProperty = this.updateContextProperty.bind(this);
    }

    addContextProperty(property, insertedName, description) {
        const newContextProperty = {
            loadToContextProperty: insertedName,
            propertyName: property
        };
        const newContextProp = {
            name: insertedName,
            publicName: "",
            description: description,
            addedByUpdater: true
        };
        if(this.props.contextProperties.some((prop) => prop.name === insertedName)){
            this.props.showToastForFrontend(messageCodes.DUPLICATE_PROPERTY_ERROR);
        }
        else {
            this.props.addUpdaterContextProperty(this.props.updaterIndex, newContextProperty);
            this.props.addContextProperty(newContextProp);
        }
    }

    deleteContextProperty(propertyIndex) {
        const toBeDeletedContextProp = this.props.contextProperties.find(
            contextProp => contextProp.name === this.props.contextUpdater.data.contextProperties[propertyIndex].loadToContextProperty
        );
        this.props.removeUpdaterContextProperty(this.props.updaterIndex, propertyIndex);
        this.props.removeContextProperty(toBeDeletedContextProp);
    }

    updateContextProperty(propertyIndex, property, value) {
        this.props.updateUpdaterContextProperty(this.props.updaterIndex, propertyIndex, property, value);
        if(property === "loadToContextProperty"){
            this.props.updateContextProperty(this.props.contextUpdater.data.contextProperties[propertyIndex].loadToContextProperty, "name", value);
        }
    }

    onEditSelected() {
        this.setState((prevState) => ({
            isEditSelected: !prevState.isEditSelected
        }));
    }

    onDeleteSelected() {
        if(Object.prototype.hasOwnProperty.call(this.props.contextUpdater.data, "contextProperties")) {
            this.props.contextUpdater.data.contextProperties.forEach(property => {
                this.props.removeContextProperty({
                    name: property.loadToContextProperty
                });
            });
        }
        this.props.removeContextUpdater(this.props.updaterIndex);
    }

    render() {
        const displayRelatedEditor = () => {
            return <ContextPropertyEditor contextUpdater={this.props.contextUpdater}
                                          updaterIndex={this.props.updaterIndex}
            />;
        };
        return (
            <div className="context-updater-section">
                <div className="context-updater-wrapper">
                    <div className="context-updater-editor">
                        <div className="updater-name" style={{display: "flex", flexDirection: "row", alignItems: 'center'}}>
                            <InputDragHandle/>
                            <span className="updated-props">Updated context property:</span>
                        {this.props.contextUpdater.data ?
                            <span style={{fontWeight: "bold"}}>{this.props.contextUpdater.data?.compositeFieldName}</span>
                         : <span>Property name not defined</span>}

                        </div>
                        <div className={"edit-button-wrapper " + (this.state.isEditSelected ? "active" : "")} onClick={this.onEditSelected}>
                            <span className="edit-label">{this.state.isEditSelected ? "Close" : "Edit"}</span>
                            <MaterialIcon icon="keyboard_arrow_down"/>
                        </div>
                        <div className="delete-button-wrapper" onClick={this.onDeleteSelected}>
                            <button className="delete-button">
                                <MaterialIcon icon="close"/>
                            </button>
                        </div>
                    </div>
                </div>
                {this.state.isEditSelected && displayRelatedEditor()}
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        contextProperties: state.contextProperties
    }
}
export default connect(mapStateToProps, {
    addContextProperty,
    removeContextProperty,
    updateContextProperty,
    removeContextUpdater,
    updateContextUpdater,
    addUpdaterContextProperty,
    removeUpdaterContextProperty,
    updateUpdaterContextProperty,
    showToastForFrontend
})(ContextUpdater);